import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import getLibBusinessesHandler from "./get-businesses.handler";
import startBusinessesHandler from "./start-business.handler";
import upgradeBusinessesCharHandler from "./upgrade-business-char.handler";
import upgradeBusinessesElementHandler from "./upgrade-business-element.handler";
import { setElementUpgradeStateHandler } from "./set-element-upgrade-state.handler";
import setBusinessNameHandler from "./set-business-name.handler";

export enum BusinessCharType {
    Area = 1,
    Staff = 2,
}

export interface IBusinessChar {
    cost: number;
    currentValue: number;
    nextValue: number;
}

export interface IBusinessElementState {
    profit: number;
    area: number;
    staff: number;
}

export enum BusinessElementDependencyType {
    Element = 1,
    Game = 2,
}

export enum BusinessElementGameDependencyType {
    Referal = 1,
}

export interface IBusinessElementDependency {
    reqType: BusinessElementDependencyType;
    type: number | BusinessElementGameDependencyType;
    value: number;
}

export interface IBusinessElement {
    type: number;
    name: string;
    level: number;
    cost: number;

    current: IBusinessElementState;
    next: IBusinessElementState | null;

    dependency?: IBusinessElementDependency;
    isAllowUpgrade?: boolean;
}

export interface IBusinesses {
    id: number;
    type: number;
    name: string;
    profit: number;
    progress: number;

    area: IBusinessChar;
    staff: IBusinessChar;

    elements: IBusinessElement[];
}

export interface ILibBusiness {
    id: number;
    name: string;
    cost: number;
}

export interface IBusinessesState extends IRequestState {
    lib: ILibBusiness[];
    businesses: IBusinesses[];
    activeBusiness: IBusinesses | null;
};

const initialState: IBusinessesState = {
    lib: [],
    businesses: [],
    activeBusiness: null,
    
    loading: false,
    error: "",
};

const businessesSlice = createSlice({
    name: 'businesses',
    initialState,
    reducers: {
        setElementUpgradeState: setElementUpgradeStateHandler
    },
    extraReducers: (builder: ActionReducerMapBuilder<IBusinessesState>) => {
        getLibBusinessesHandler(builder);
        startBusinessesHandler(builder);
        upgradeBusinessesCharHandler(builder);
        upgradeBusinessesElementHandler(builder);
        setBusinessNameHandler(builder);
    },
});

export default businessesSlice.reducer;
export const { setElementUpgradeState } = businessesSlice.actions;